import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import getAPIbaseURL from "../../utils/helpers";

const API_URL = `${getAPIbaseURL()}/activity_logs`;

export const createActivityLog = createAsyncThunk(
  "activityLogs/create",
  async (logData, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(`${API_URL}/`, logData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Error creating activity log");
    }
  }
);

export const fetchActivityLogs = createAsyncThunk(
  "activityLogs/fetch",
  async (filters = {}, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const params = new URLSearchParams(filters).toString();
      const response = await axios.get(`${API_URL}?${params}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Error fetching activity logs");
    }
  }
);

const activityLogsSlice = createSlice({
  name: "activityLogs",
  initialState: {
    logs: [],
    isLoading: false,
    error: null,
    message: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createActivityLog.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createActivityLog.fulfilled, (state, action) => {
        state.isLoading = false;
        state.logs.unshift(action.payload);
        state.message = "Activity log created successfully";
      })
      .addCase(createActivityLog.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchActivityLogs.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchActivityLogs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.logs = action.payload;
      })
      .addCase(fetchActivityLogs.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default activityLogsSlice.reducer;